import e from"styled-components";const i=e.div`
	height: 100%;
	box-sizing: border-box;
	padding: 1rem;
	display: grid;
	position: relative;
`,t=e.div`
	position: absolute;
	top: 40%;
	left: 10%;
	right: 10%;
	bottom: 0;
	border-radius: 1214px;
	opacity: 0.2;
	background: #00afff;
	filter: blur(105px);
	z-index: 0;
`,n=e.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	margin: 0 auto;
	position: relative;
	z-index: 1;
`,o=e.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
	margin: 0 auto;
	width: 65%;
	margin-top: 55px;
`,r=e.h1`
	background: linear-gradient(180deg, #039eeb -7.5%, #bee9f9 100.36%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	text-align: center;
	font-family: "PP Formula";
	font-size: 64px;
	font-style: normal;
	font-weight: 500;
	line-height: 109%; /* 69.76px */
	letter-spacing: -2.56px;
	margin-block: 0px;
`,a=e.p`
	color: #868686;
	text-align: center;
	font-family: "SF Pro Display";
	font-size: 21px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%;
	margin-block: 0px;
`,l=e.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 24px;
`;e.div`
	background: url("https://caelor-apps.web.app/images/dex/banner/banner-image-1.png");
	width: 100%;
	height: 320px;
	margin-top: 80px;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	align-self: flex-end;
	position: relative;
	z-index: 1;
`;const p=e.div`
	width: calc(100% + 2rem);
	margin-left: -1rem;
	background-color: ${({theme:e})=>e.bg.general};
`,d=e.video`
	width: 100%;
	padding-inline: 4rem;
	box-sizing: border-box;
	margin-top: 10%;
	position: relative;
	z-index: 1;
	object-fit: cover;
`,g=e.div`
	position: fixed;
	display: grid;
	place-content: center;
	bottom: 115px;
	inset-inline: 0;
	width: 900px;
	margin: 0 auto;
	z-index: 100;
`;export{t as BannerBackgroundBlur,l as BannerButtons,i as BannerContainer,n as BannerContent,a as BannerDescription,o as BannerInfo,r as BannerTitle,d as BannerVideo,g as FloatingBannerContainer,p as VideoContainer};
